import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import { useLazyGetSpecificCategoryByIdQuery } from "../../services/category";
import Loader from "../../helpers/constants/Loader";
import Pagination from "../../components/Pagination";
import { useLazyGetPropertyForCategoryDetailsQuery } from "../../services/property";

const CategoryDetails = () => {
  const { _id } = useParams();
  const [categoryDetails, setCategoryDetails] = useState<any>({});
  const [fetchApi, { isLoading }] = useLazyGetSpecificCategoryByIdQuery();
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [properties, setProperties] = useState<any[]>([]);
  const [getProperties] = useLazyGetPropertyForCategoryDetailsQuery();

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const [limit, setLimit] = useState<number>(10);
  let totalPages = Math.ceil(totalCount / limit);
  const fetchDataById = async () => {
    try {
      const response = await fetchApi({ userId: _id }).unwrap();
      if (response.statusCode === 200) {
        setCategoryDetails(response?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDataByIdProperties = async () => {
    try {
      const response = await getProperties({ page: page, limit: limit, category: _id }).unwrap();
      if (response.statusCode === 200) {
        setProperties(response?.data?.property || []);
        setTotalCount(response?.data?.count)
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (_id) fetchDataById();
  }, []);

  useEffect(() => {
    if (_id) fetchDataByIdProperties()
  }, [page, limit])

  const navigate = useNavigate();

  return (
    <div>
      <Loader isLoad={isLoading} />
      <div className="main_layout">
        <div className="dashboard" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 className="mn_hdng">Category Details</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-categories");
            }}
          >
            Back
          </Button>
        </div>
        <Box className="cat_name">
          {categoryDetails.image && (
            <figure>
              <img
                src={categoryDetails.image}
                alt="Category"
              />
            </figure>
          )}
          <Typography variant="h5">Category Name: <strong>{categoryDetails.name}</strong></Typography>
        </Box>
        <Card className="cards">
          <TableContainer className="table_container" style={{ marginTop: 0 }}>
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>Images</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Area</TableCell>
                  <TableCell>Key Feature</TableCell>
                  <TableCell>Specifications</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {properties.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No property in this category
                    </TableCell>
                  </TableRow>
                ) : (
                  properties.map((property: any, i: any) => (
                    <TableRow key={property._id}>
                      <TableCell align="center">
                        {(page - 1) * 10 + i + 1}
                      </TableCell>
                      <TableCell>
                        {property?.images?.length
                          ? <img
                            src={property.images[0]}
                            alt={`Property ${i + 1}`}
                            style={{ width: "50px", height: "50px" }}
                          />
                          : "-"}
                      </TableCell>
                      <TableCell>{property?.name || "-"}</TableCell>
                      <TableCell>{property?.area || "-"}</TableCell>
                      <TableCell>{property?.keyFeature || "-"}</TableCell>
                      <TableCell>{property?.specifications || "-"}</TableCell>
                      <TableCell>{property?.address || "-"}</TableCell>
                      <TableCell>{property?.description || "-"}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>
      {totalCount > 0 ? (
        <Pagination
          setPage={setPage}
          module={categoryDetails}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
          limit={limit}
          setLimit={setLimit}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default CategoryDetails;
